export const userConpon = (r) => require.ensure([], () => r(require("./userCoupon/index.vue")), "userCoupon");
export const couponCenter = (r) => require.ensure([], () => r(require("./couponCenter/index.vue")), "couponCenter");
export const couponTurn = (r) => require.ensure([], () => r(require("./couponTurn/couponTurn.vue")), "couponTurn");
